/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popSign.vue?vue&type=template&id=3c6e4f4e&scoped=true"
import script from "./popSign.vue?vue&type=script&lang=js"
export * from "./popSign.vue?vue&type=script&lang=js"
import style0 from "./popSign.vue?vue&type=style&index=0&id=3c6e4f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6e4f4e",
  null
  
)

export default component.exports